var map = {
	"./Award": 52,
	"./Award.js": 52,
	"./BookOpen": 53,
	"./BookOpen.js": 53,
	"./BookOpen.svg": 54,
	"./CityVision.png": 55,
	"./Coffeee": 56,
	"./Coffeee.js": 56,
	"./CreditCardDel.png": 57,
	"./ExternalLink": 58,
	"./ExternalLink.js": 58,
	"./FB.svg": 59,
	"./Facebook": 60,
	"./Facebook.js": 60,
	"./Github": 61,
	"./Github.js": 61,
	"./GradHat.png": 24,
	"./GradHatG.png": 62,
	"./HomomorphicEncryption.png": 63,
	"./Instagram": 64,
	"./Instagram.js": 64,
	"./Linkedin": 65,
	"./Linkedin.js": 65,
	"./Logo.png": 66,
	"./LogoLarge": 19,
	"./LogoLarge.js": 19,
	"./LogoSmall": 67,
	"./LogoSmall.js": 67,
	"./RDMVS.png": 68,
	"./Substack": 69,
	"./Substack.js": 69,
	"./Terminal": 70,
	"./Terminal.js": 70,
	"./Twitter": 71,
	"./Twitter.js": 71,
	"./Work": 72,
	"./Work.js": 72,
	"./handwritingDetection.png": 73,
	"./twitter.svg": 74,
	"./universal_photo.jpeg": 75,
	"./universal_photo_1.jpeg": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;